// Detect high-quality ICT confluences and surface them as quick-jump prompts.
// A "prompt" = a candidate trade-study moment where ≥2 ICT concepts align within a small bar window.

export function buildPrompts(analysis, bars, opts = {}) {
  if (!bars.length) return [];
  const lookback = opts.lookback || 5;
  const prompts = [];
  // Index events by bar
  const fvgByBar = {};
  analysis.fvgs.forEach(f => { (fvgByBar[f.index] ||= []).push(f); });
  const sweepByBar = {};
  analysis.sweeps.forEach(s => { (sweepByBar[s.index] ||= []).push(s); });
  const structByBar = {};
  analysis.structure.forEach(s => { (structByBar[s.index] ||= []).push(s); });
  const smtByBar = {};
  analysis.smt.forEach(s => { (smtByBar[s.index] ||= []).push(s); });

  for (let i = 5; i < bars.length; i++) {
    const window = [];
    let bullScore = 0, bearScore = 0;
    let pieces = [];
    for (let j = Math.max(0, i - lookback); j <= i; j++) {
      (fvgByBar[j] || []).forEach(f => {
        if (f.type === "bullish") { bullScore++; pieces.push("Bullish FVG"); }
        else { bearScore++; pieces.push("Bearish FVG"); }
      });
      (sweepByBar[j] || []).forEach(s => {
        if (s.type === "sellside") { bullScore++; pieces.push("SSL purge"); }
        else { bearScore++; pieces.push("BSL purge"); }
      });
      (structByBar[j] || []).forEach(s => {
        if (s.direction === "bullish") { bullScore += s.type === "MSS" ? 2 : 1; pieces.push(`${s.type}↑`); }
        else { bearScore += s.type === "MSS" ? 2 : 1; pieces.push(`${s.type}↓`); }
      });
      (smtByBar[j] || []).forEach(s => {
        if (s.type === "bullish_smt") { bullScore++; pieces.push("Bullish SMT"); }
        else { bearScore++; pieces.push("Bearish SMT"); }
      });
    }
    const score = Math.max(bullScore, bearScore);
    if (score >= 3 && pieces.length >= 2) {
      // dedupe pieces
      const uniqPieces = [...new Set(pieces)].slice(0, 4);
      prompts.push({
        index: i,
        time: bars[i].time,
        direction: bullScore > bearScore ? "long" : "short",
        score,
        concepts: uniqPieces,
        price: bars[i].close,
        region: analysis.premiumDiscount
          ? (bars[i].close > analysis.premiumDiscount.eq ? "premium" : "discount")
          : "—",
      });
      i += lookback; // avoid overlapping cluster
    }
  }
  return prompts.slice(-20); // last 20 only
}
